import { TrainingsCheckmark } from '@/react/componentAssets/TrainingsCheckmark'
import classNames from 'classnames'
import Highlighter from 'react-highlight-words'
import { User } from '@/react/types/observations'

interface AssignInternalRowProps {
  index: number
  user: User
  handleSelect: (userId: number) => void
  variableColor: string
  search: string
  checked: boolean
}

const AssignInternalRow = ({
  index,
  user,
  handleSelect,
  variableColor,
  search,
  checked,
}: AssignInternalRowProps) => {
  return (
    <tr
      className={classNames('assign-internal-row', {
        dark: index % 2 === 0,
      })}
      key={user.id}
    >
      <td className="checkbox-td">
        <label className="checkbox-container">
          <input
            type="checkbox"
            checked={checked}
            onChange={() => {
              handleSelect(user.id)
            }}
          />
          <span className="checkmark">
            <TrainingsCheckmark color={variableColor} />
          </span>
        </label>
      </td>
      <td className="name-td">
        <p className="cell">
          <Highlighter
            highlightClassName={'highlighted__item'}
            textToHighlight={user.first_name + ' ' + user.last_name}
            searchWords={[search]}
            autoEscape={true}
            highlightStyle={{
              backgroundColor: `${variableColor}40`,
            }}
          />
        </p>
      </td>
      <td className="id-td">
        <p className="cell">
          <Highlighter
            highlightClassName={'highlighted__item'}
            textToHighlight={user.employee_id}
            searchWords={[search]}
            autoEscape={true}
            highlightStyle={{
              backgroundColor: `${variableColor}40`,
            }}
          />
        </p>
      </td>
    </tr>
  )
}

export default AssignInternalRow
